// @flow
import actionTypes from '../actionTypes';
import { fetch } from '../../api';
import { fetchData } from './dataActionsCreator';

export function formatPayload(payload, showPrivateFields): Object {
  // @TODO REMOVE HACK : back end is providing busted data
  // NON TESTED
  const groups = (payload.user && payload.user.groups) || [];
  groups.forEach(g => {
    delete g.postCount;
    delete g.memberCount;
    g.isFollowing = true;
  });
  // @TODO REMOVE HACK

  const user = {
    ...payload.user,
    privateFieldsFetched: showPrivateFields || undefined,
  };

  return { users: [user] };
}

export async function fetchUser(userId: IdType, showPrivateFields: boolean = false, username: String): Object {
  const query = { userId, showPrivateFields, username };
  const { payload } = await fetch('profile', { query });

  return formatPayload(payload, showPrivateFields);
}

export function shouldAskForPrivatefield(userId: IdType, showPrivateFields: boolean, state: Object) {
  return showPrivateFields || (state.context.userId === userId);
}

export function customFetch(userId: IdType, showPrivateFields: boolean = false) {
  return (getState: GetState) => {
    const state = getState();

    // @FIXME HACK TO REMOVE - START
    const user = state.data.users[userId] || {};
    const username = user.username;
    // @FIXME HACK TO REMOVE - END

    const showPrivate = shouldAskForPrivatefield(userId, showPrivateFields, state);
    return fetchUser(userId, showPrivate, username);
  };
}

export function fetchUserAction(userId: IdType, showPrivateFields: boolean = false) {
  return fetchData(customFetch(userId, showPrivateFields));
}

export function restrict(details: Object) {
  // const follow = { type, id };

  return async function (dispatch) {
    try {
      await fetch('user-roles', {
        method: 'POST',
        body: JSON.stringify(details),
      });

      dispatch({ type: actionTypes.USER_RESTRICT_SUCCESS });
    } catch (error) {
      dispatch({ type: actionTypes.USER_RESTRICT_FAILURE });
    }
  };
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/userActionsCreator.js